import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0d36633f")
const _hoisted_1 = { class: "ticket" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-d-flex p-jc-around p-mb-3" }
const _hoisted_4 = { class: "ticket_data" }
const _hoisted_5 = { class: "p-d-flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-bill-wave p-mr-2" }, null, -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-field p-d-flex p-ai-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "ticket_unresolved",
  class: "p-ml-2"
}, "Unresolved", -1)
const _hoisted_10 = { class: "p-d-flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list p-mr-2" }, null, -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1)
const _hoisted_19 = {
  class: "p-field p-fluid",
  style: {"flex":"1"}
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = {
  key: 1,
  class: "p-field"
}
const _hoisted_23 = {
  key: 2,
  class: "p-field"
}
const _hoisted_24 = {
  key: 3,
  class: "p-field"
}
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = { class: "p-formgroup-inline p-ai-center" }
const _hoisted_27 = {
  key: 0,
  class: "p-field"
}
const _hoisted_28 = { class: "p-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Hours: ")
], -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 0,
  class: "p-mb-3 p-badge p-badge-info"
}
const _hoisted_33 = { class: "fee-container" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_42 = { class: "p-d-flex" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-road p-mr-2" }, null, -1)
const _hoisted_44 = { class: "p-d-flex p-jc-around p-ai-center p-mb-3" }
const _hoisted_45 = {
  key: 0,
  class: "pi pi-arrow-left p-mx-3",
  style: {"font-size":"1.5rem"}
}
const _hoisted_46 = {
  key: 1,
  class: "pi pi-arrow-right p-mx-3",
  style: {"font-size":"1.5rem"}
}
const _hoisted_47 = {
  key: 2,
  class: "p-mx-2"
}
const _hoisted_48 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_49 = { class: "p-offset-6 p-col-6" }
const _hoisted_50 = { class: "free_dump_container" }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 0,
  class: "p-text-right p-mt-2"
}
const _hoisted_56 = {
  key: 0,
  class: "p-d-flex p-ai-center p-jc-between"
}
const _hoisted_57 = { class: "p-d-flex p-flex-column p-ml-3" }
const _hoisted_58 = { class: "p-mt-3" }
const _hoisted_59 = { class: "p-field p-fluid" }
const _hoisted_60 = { class: "p-field p-fluid" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file p-mr-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Private close-out note")
], -1)
const _hoisted_62 = { class: "p-field p-fluid" }
const _hoisted_63 = {
  key: 3,
  class: "ticket_actions"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldsetSkeleton = _resolveComponent("FieldsetSkeleton")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_MomentZoneCalendar = _resolveComponent("MomentZoneCalendar")!
  const _component_ContractAutocomplete = _resolveComponent("ContractAutocomplete")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ZoneCard = _resolveComponent("ZoneCard")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_TicketDriverData = _resolveComponent("TicketDriverData")!
  const _component_TicketHistory = _resolveComponent("TicketHistory")!
  const _component_TicketFinishStatus = _resolveComponent("TicketFinishStatus")!
  const _component_TicketDisputeResolverDialog = _resolveComponent("TicketDisputeResolverDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.ticket || _ctx.requestPending)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(_component_FieldsetSkeleton),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "5rem"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "5rem",
              class: "p-ml-3"
            })
          ]),
          _createVNode(_component_FieldsetSkeleton),
          _createVNode(_component_TableSkeleton, {
            columns: "3",
            rows: "5"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "5rem"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            height: "5rem"
          })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", _hoisted_4, [
            (_ctx.isClosed && !_ctx.isBroker && !_ctx.isDeleted)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 0,
                  class: "p-mb-3 relative",
                  toggleable: ""
                }, {
                  legend: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('ticket.payment')), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("form", {
                      id: "payment",
                      class: "p-formgroup-inline p-ai-center",
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePayment && _ctx.updatePayment(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('ticket.payment_status')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Dropdown, {
                              modelValue: _ctx.ticket.payment_status,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.ticket.payment_status = $event)),
                              disabled: _ctx.isReadOnly,
                              options: _ctx.paymentStatusOptions,
                              showClear: true,
                              optionLabel: "label",
                              optionValue: "value"
                            }, null, 8, ["modelValue", "disabled", "options"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Checkbox, {
                          inputId: "ticket_unresolved",
                          modelValue: _ctx.ticket.ticket_unresolved,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ticket.ticket_unresolved = $event)),
                          binary: true,
                          disabled: _ctx.isReadOnly
                        }, null, 8, ["modelValue", "disabled"]),
                        _hoisted_9
                      ]),
                      (!_ctx.isReadOnly)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            type: "submit",
                            form: "payment",
                            icon: "pi pi-save",
                            style: {"position":"absolute","top":"-1rem","right":"1rem"},
                            disabled: _ctx.requestPending
                          }, null, 8, ["disabled"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('save'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ], 32)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isDeleted)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 1,
                  class: "p-mb-3 relative",
                  toggleable: "",
                  disabled: _ctx.isReadOnly
                }, {
                  legend: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('ticket.data')), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("form", {
                      id: "ticket_data",
                      onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("fieldset", {
                        class: "p-formgroup-inline p-ai-center p-p-0",
                        style: {"border":"none"},
                        disabled: _ctx.ticketPaidOrAuthorized
                      }, [
                        (_ctx.isClosed  && (_ctx.isSuperAdmin || _ctx.isCustomer))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_FloatLabel, {
                                  label: _ctx.$t('ticket.extra_driver'),
                                  style: {"min-width":"0","align-self":"flex-end"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputNumber, {
                                      modelValue: _ctx.ticket.extra_fee_driver,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ticket.extra_fee_driver = $event)),
                                      mode: "currency",
                                      currency: "USD",
                                      locale: "en-US"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_FloatLabel, {
                                  label: _ctx.$t('ticket.extra_broker'),
                                  style: {"min-width":"0","align-self":"flex-end"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputNumber, {
                                      modelValue: _ctx.ticket.extra_fee_broker,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ticket.extra_fee_broker = $event)),
                                      mode: "currency",
                                      currency: "USD",
                                      locale: "en-US"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_FloatLabel, {
                                  label: _ctx.$t('ticket.extra_customer'),
                                  style: {"min-width":"0","align-self":"flex-end"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputNumber, {
                                      modelValue: _ctx.ticket.extra_fee_customer,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.ticket.extra_fee_customer = $event)),
                                      mode: "currency",
                                      currency: "USD",
                                      locale: "en-US"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_FloatLabel, {
                                  label: _ctx.$t('ticket.extra_system'),
                                  style: {"min-width":"0","align-self":"flex-end"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputNumber, {
                                      modelValue: _ctx.ticket.extra_fee_system,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ticket.extra_fee_system = $event)),
                                      mode: "currency",
                                      currency: "USD",
                                      locale: "en-US"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _createVNode(_component_Divider),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_FloatLabel, {
                                  label: _ctx.$t('ticket.broker_deduct'),
                                  style: {"min-width":"0","align-self":"flex-end"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InputNumber, {
                                      modelValue: _ctx.ticket.broker_deduct,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.ticket.broker_deduct = $event)),
                                      min: 0,
                                      max: 100
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _hoisted_18,
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_FloatLabel, {
                                  label: _ctx.$t('ticket.broker_deduct_note')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Textarea, {
                                      autoresize: true,
                                      modelValue: _ctx.ticket.broker_deduct_note,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.ticket.broker_deduct_note = $event)),
                                      rows: 3
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _createVNode(_component_Divider)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_FloatLabel, {
                            label: _ctx.$t('ticket.assigned_time')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MomentZoneCalendar, {
                                timezone: _ctx.ticket.zone_name,
                                moment: _ctx.ticket.datetime_assigned,
                                "onUpdate:moment": _cache[9] || (_cache[9] = ($event: any) => (_ctx.ticket.datetime_assigned = $event)),
                                disabled: !_ctx.isAcceptedByUser
                              }, null, 8, ["timezone", "moment", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_FloatLabel, {
                            label: _ctx.$t('ticket.start_time')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MomentZoneCalendar, {
                                timezone: _ctx.ticket.zone_name,
                                moment: _ctx.ticket.datetime_start,
                                "onUpdate:moment": _cache[10] || (_cache[10] = ($event: any) => (_ctx.ticket.datetime_start = $event)),
                                disabled: !_ctx.isClosed
                              }, null, 8, ["timezone", "moment", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        (_ctx.isClosed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_FloatLabel, {
                                label: _ctx.$t('ticket.end_time')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_MomentZoneCalendar, {
                                    timezone: _ctx.ticket.zone_name,
                                    moment: _ctx.ticket.datetime_end,
                                    "onUpdate:moment": _cache[11] || (_cache[11] = ($event: any) => (_ctx.ticket.datetime_end = $event))
                                  }, null, 8, ["timezone", "moment"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isClosed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(_component_FloatLabel, {
                                label: _ctx.$t('ticket.cycles'),
                                style: {"min-width":"0"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_InputNumber, {
                                    modelValue: _ctx.ticket.cycles,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.ticket.cycles = $event)),
                                    class: "input_small",
                                    min: 0,
                                    required: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isClosed && _ctx.canSeeTotalTon)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createVNode(_component_FloatLabel, {
                                label: _ctx.$t('ticket.total_ton'),
                                style: {"min-width":"0","align-self":"flex-end"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_InputNumber, {
                                    modelValue: _ctx.ticket.total_ton,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.ticket.total_ton = $event)),
                                    mode: "decimal",
                                    minFractionDigits: 1,
                                    disabled: !_ctx.isClosed
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_ContractAutocomplete, {
                            forceSelection: true,
                            contractId: _ctx.ticket.contract_id,
                            modelValue: _ctx.ticket.contract,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.ticket.contract = $event)),
                            onSelect: _ctx.onContractSelect,
                            disabled: !_ctx.isBtnSaveTicketDataVisible
                          }, null, 8, ["contractId", "modelValue", "onSelect", "disabled"])
                        ])
                      ], 8, _hoisted_12)
                    ], 32),
                    _createElementVNode("div", _hoisted_26, [
                      (!_ctx.isClosed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("span", null, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.cycles')) + ": ", 1)
                            ]),
                            _createElementVNode("i", null, _toDisplayString(_ctx.$t('In progress')) + " (" + _toDisplayString(_ctx.ticket.cycles) + ")", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        (_ctx.hasEndDate)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_30, "(" + _toDisplayString(_ctx.duration) + ")", 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_31, _toDisplayString(_ctx.$t('In progress')) + " (" + _toDisplayString(_ctx.duration) + ")", 1))
                      ])
                    ]),
                    (_ctx.isClosed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_Divider),
                          (_ctx.isCalcFeeInProgress)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Calculating..."))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.fee_driver')), 1),
                              _hoisted_34,
                              _createVNode(_component_CurrencyText, {
                                modelValue: _ctx.ticket.fee_driver
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.fee_broker')), 1),
                              _hoisted_35,
                              _createVNode(_component_CurrencyText, {
                                modelValue: _ctx.ticket.fee_broker
                              }, null, 8, ["modelValue"])
                            ]),
                            (!_ctx.isBroker)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.fee_customer')), 1),
                                  _hoisted_37,
                                  _createVNode(_component_CurrencyText, {
                                    modelValue: _ctx.ticket.fee_customer
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isBroker)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.fee_system')), 1),
                                  _hoisted_39,
                                  _createVNode(_component_CurrencyText, {
                                    modelValue: _ctx.ticket.fee_system
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isBroker)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.fee_client')), 1),
                                  _hoisted_41,
                                  _createVNode(_component_CurrencyText, {
                                    modelValue: _ctx.ticket.fee_client
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.isBtnSaveTicketDataVisible)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          type: "submit",
                          form: "ticket_data",
                          icon: "pi pi-save",
                          style: {"position":"absolute","top":"-1rem","right":"1rem"},
                          disabled: _ctx.requestPending
                        }, null, 8, ["disabled"])), [
                          [
                            _directive_tooltip,
                            _ctx.$t('save'),
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Fieldset, {
              class: "p-mb-3 relative",
              toggleable: ""
            }, {
              legend: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('ticket.shift_data')), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("h5", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('ticket.shift_name')) + ": ", 1),
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.shiftRoute,
              params: {
                shiftId: _ctx.ticket.shift_id
              }
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(_ctx.ticket.shift_id) + " - " + _toDisplayString(_ctx.ticket.shift?.code), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.ticket.shift?.weather_condition ?
              `(${_ctx.ticket.shift.weather_condition})` : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_ZoneCard, {
                    zoneTitle: "Load Site (LS)",
                    zone: _ctx.ticket.shift.zone_load
                  }, null, 8, ["zone"]),
                  (_ctx.isGoingToLoad)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                    : (_ctx.isGoingToDump)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                      : (_openBlock(), _createElementBlock("span", _hoisted_47)),
                  _createVNode(_component_ZoneCard, {
                    zoneTitle: "Dump Site (TZ)",
                    zone: _ctx.ticket.shift.zone_dump
                  }, null, 8, ["zone"])
                ]),
                (_ctx.ticket.free_dump_requested_at)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.free_dump_requested_at')) + ": ", 1),
                            (_ctx.ticket.free_dump_requested_at)
                              ? (_openBlock(), _createBlock(_component_DateFormatted, {
                                  key: 0,
                                  date: _ctx.ticket.free_dump_requested_at,
                                  format: "YYYY-MM-DD hh:mm A"
                                }, null, 8, ["date"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_51, "--"))
                          ]),
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.free_dump_accepted_at')) + ": ", 1),
                            (_ctx.ticket.free_dump_accepted_at)
                              ? (_openBlock(), _createBlock(_component_DateFormatted, {
                                  key: 0,
                                  date: _ctx.ticket.free_dump_accepted_at,
                                  format: "YYYY-MM-DD hh:mm A"
                                }, null, 8, ["date"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_52, "--"))
                          ]),
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.free_dump_note')) + ": ", 1),
                            (_ctx.ticket.free_dump_note)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.ticket.free_dump_note), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_54, "--"))
                          ])
                        ]),
                        (_ctx.freeDumpRequestVisible)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_55, [
                              _createVNode(_component_Button, {
                                disabled: _ctx.free_dump_accepting,
                                label: "Accept free dump request",
                                class: "p-button-danger",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.acceptFreeDumpRequest()))
                              }, null, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_TicketDriverData, {
              ticket: _ctx.ticket,
              toggleable: ""
            }, null, 8, ["ticket"])
          ]),
          _createVNode(_component_Divider),
          _createVNode(_component_TicketHistory, {
            ticket: _ctx.ticket,
            timeZone: _ctx.ticket.zone_name,
            hiddenColumns: _ctx.hiddenHistoryColumns
          }, null, 8, ["ticket", "timeZone", "hiddenColumns"]),
          (_ctx.isClosed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ticket.final_status')) + ": ", 1)
                  ]),
                  (_ctx.ticket)
                    ? (_openBlock(), _createBlock(_component_TicketFinishStatus, {
                        key: 0,
                        ticket: _ctx.ticket
                      }, null, 8, ["ticket"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('ticket.dispute_note')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    readonly: true,
                    autoResize: true,
                    modelValue: _ctx.ticket.dispute_note
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('ticket.finish_note')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    readonly: true,
                    autoResize: true,
                    modelValue: _ctx.ticket.finish_note
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode(_component_Divider),
          ((_ctx.isSuperAdmin || _ctx.isCustomer))
            ? (_openBlock(), _createBlock(_component_Fieldset, {
                key: 1,
                class: "p-mb-3 relative"
              }, {
                legend: _withCtx(() => [
                  _hoisted_61
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_FloatLabel, {
                      label: _ctx.$t('ticket.private_closeout_note')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Textarea, {
                          autoResize: true,
                          modelValue: _ctx.ticket.private_closeout_note,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.ticket.private_closeout_note = $event)),
                          class: "p-mt-2"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-save",
                    style: {"position":"absolute","top":"-1rem","right":"1rem"},
                    class: "p-mr-1 p-button-success",
                    onClick: _ctx.updatePrivateCloseoutNote
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.isSuperAdmin || _ctx.isCustomer))
            ? (_openBlock(), _createBlock(_component_Divider, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.showActions)
            ? (_openBlock(), _createElementBlock("footer", _hoisted_63, [
                (!_ctx.isDispute && !_ctx.isClosed)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: _ctx.$t('ticket.actions.force_closure'),
                      class: "p-mr-2 p-button-warning",
                      icon: "pi pi-lock",
                      onClick: _ctx.closeTicket
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isDispute && !_ctx.isBroker)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: _ctx.$t('ticket.actions.resolve_dispute'),
                      class: "p-mr-2 p-button-info",
                      icon: "pi pi-comment",
                      onClick: _ctx.disputeTicket
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.canDelete)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      label: _ctx.trashLabel,
                      class: "p-mr-2 p-button-danger",
                      icon: "pi pi-trash",
                      onClick: _ctx.onDelete
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_TicketDisputeResolverDialog, {
            ticket: _ctx.ticket,
            visible: _ctx.displayResolverDialog,
            "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => (_ctx.displayResolverDialog = $event)),
            header: _ctx.dialogHeader,
            position: "bottomright",
            onResolved: _ctx.onResolved,
            onCancel: _ctx.onResolveCancel
          }, null, 8, ["ticket", "visible", "header", "onResolved", "onCancel"])
        ], 64))
  ]))
}